import { createAction } from 'redux-actions';

export const GetSurveyRequested = createAction('GET_SURVEY_REQUESTED');
export const GetSurveyReceived = createAction('GET_SURVEY_RECEIVED');
export const GetSurveyReceiveFailure = createAction('GET_SURVEY_RECEIVE_FAILURE');
export const ClearGetSurvey = createAction('CLEAR_GET_SURVEY');

export const UpdateSurveyRequested = createAction('UPDATE_SURVEY_REQUESTED');
export const UpdateSurveyReceived = createAction('UPDATE_SURVEY_RECEIVED');
export const UpdateSurveyReceiveFailure = createAction('UPDATE_SURVEY_RECEIVE_FAILURE');
export const ClearUpdateSurvey = createAction('CLEAR_UPDATE_SURVEY');
